import { STORAGE_KEY } from '../config/constants';
import type { ModelSnapshot } from '../game/types';

export function saveSnapshot(snapshot: ModelSnapshot): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(snapshot));
  } catch (error) {
    console.warn('[压力清空所] 无法保存本地进度，继续以无存档模式运行。', error);
  }
}

export function loadSnapshot(): ModelSnapshot | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? (JSON.parse(raw) as ModelSnapshot) : null;
  } catch (error) {
    console.warn('[压力清空所] 本地进度无效，已使用新游戏。', error);
    return null;
  }
}

export function clearSnapshot(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    console.warn('[压力清空所] 无法清除本地进度。', error);
  }
}
